import { Injectable } from '@angular/core';
import { Headers, Http } from '@angular/http';
import { ApiEvsService } from 'app/common/services/ApiEvs.service';
import { environment } from '../../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
@Injectable()
export class IdentifierService {
  url = environment.qrcode_url;
  headers: Headers;
  constructor(
    private http: ApiEvsService,
    private http2: Http,
  ) {
    const token = localStorage.getItem('Access-Token');
    this.headers = new Headers({
      "Accept-Language": localStorage.getItem("lang") || "vi",
      'Content-Type': 'application/json',
      'Authorization': `${token}`
    });
  }

  public getLogsScan(data?: any) {
    return this.http.get('/logs/scan', data);
  }
  public getExcel(data?: any) {
    return this.http.getExcel('/logs/scan/excel', data);
  }
  public getLogsDetail(id?: any) {
    return this.http.get('/logs/scan/' + id);
  }
  public getLogsDetailLoyalty(id?: any, prefix?: any, number?: any): Observable<any> {
    return this.http2.get(`${this.url}/logs/scan/${id}/sale-out/loyalty?prefix=${prefix}&number=${number}`, { headers: this.headers }).map(res => {
      return res.json();
    });
  }
  // public getLogsDetailLoyalty(id?: any) {
  //   return this.http2.get(`${this.url}/logs/scan/${id}/sale-out/loyalty`,);
  // }

  public getOverviewData() {
    return this.http.get('/dashboard/identity/overview');
  }

  public stampBatchesList(data?: any) {
    return this.http.get('/batches', data);
  }
}
// get list: https://qrcode-test-api.icheck.vn/logs/scan?scan_service_type=1
//   get overview: https://qrcode-test-api.icheck.vn/dashboard/identity/overview
// export excel: https://qrcode-test-api.icheck.vn/logs/scan/identity/excel?&sort_by=ins_dt:desc&Access_Token=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJwaG9uZSI6IjAzOTkwMzg1NSIsInVzZXJfaWQiOjQxNDksIm93bmVyX2lkIjo0MTQ5LCJpc3MiOiI4NDk2MzQzNDEyMSIsInR5cGUiOjEsImV4cCI6MTYxMTU1NzI4OCwiZW1haWwiOiJ5ZW5kdEBnbWFpbC5jb20iLCJ1c2VybmFtZSI6Ijg0OTYzNDM0MTIxIn0.wufX0uCDAsxirIWFTWYLDXSWYP4Rs6_7udA1rkja3wk



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/identifier/identifier.service.ts